module.exports = __webpack_public_path__ + "static/paula-tuffin-400w-103018-fb19af7a998eb597d7575f49fc819946.jpg";